
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexni6TxoxFOmNZNcqLCPfV0CyCSopciYghrbAuyzY3iocMeta } from "/var/www/panel/pages/index.vue?macro=true";
import { default as loginFtlvZ3e0paiUJCpU9FTGEf9JY8GrqGHvyACl6prkNosMeta } from "/var/www/panel/pages/login.vue?macro=true";
import { default as terms6KrDzNGApadzvsiM5ZEN1eXLGHUoIF5k_Vg0fwSWvfUMeta } from "/var/www/panel/pages/terms.vue?macro=true";
import { default as contacteOONcYOVoFoH9pRVYVMqDZV9Z2YGtuvjQRv66HQM9eMMeta } from "/var/www/panel/pages/contact.vue?macro=true";
import { default as privacyMfIux7ciQDpbUCfsaEaaw0u9Joxb7se7QJQgb0Ongs8Meta } from "/var/www/panel/pages/privacy.vue?macro=true";
import { default as schedulelyUFOW1AlicCsYB1eITbvNUUJ7UbOm3TYlllvjXBg70Meta } from "/var/www/panel/pages/schedule.vue?macro=true";
import { default as settingsy8YdYalpq_xhnjQtuPXYfvlyqotO3QWzMPwo1i3SzCcMeta } from "/var/www/panel/pages/settings.vue?macro=true";
import { default as _91id_9339Qb_DA5OPM_45R0adH6QjBf18dkYAw_5EaskV2rKMDUkMeta } from "/var/www/panel/pages/decisions/[id].vue?macro=true";
import { default as decisionsG56DvyZR40uJuQ09U7mNcl8E0dYPL2tyjA6pLsBMB1QMeta } from "/var/www/panel/pages/decisions.vue?macro=true";
import { default as documentsKWVy_ypaauj4_RqNHWebngzB9pJWBPXKVBnzFtYMtv0Meta } from "/var/www/panel/pages/documents.vue?macro=true";
import { default as checkboxesBZ6d7UTdvGJvua6w_QUkp3oXZ2VujL0f8dBDZWmZoksMeta } from "/var/www/panel/pages/checkboxes.vue?macro=true";
import { default as login_45helpYmsXaEFhZDt_gFiyIHJrmfUdYw_45qqwoFZyFyAWcU48UMeta } from "/var/www/panel/pages/login-help.vue?macro=true";
import { default as indexIXi4rNfMefLrz5jRyPaJcVoSrkXTg1dx0FzUDor0FscMeta } from "/var/www/panel/pages/admin/index.vue?macro=true";
import { default as settlements2J3fSon7E_45WzwjpHZ4wrR7v5zsfY_ut_G3fIVblo5q4Meta } from "/var/www/panel/pages/settlements.vue?macro=true";
import { default as sentrymorWquOvgavxcEMnpiDMskvBMZ8_NRq6c_45NL5Nf7JyQMeta } from "/var/www/panel/pages/admin/sentry.vue?macro=true";
import { default as _91id_937nAyV6rzBkpiDng4Qv9_45n2SVQL3sEYpKYhgYad3HfxIMeta } from "/var/www/panel/pages/journal/[id].vue?macro=true";
import { default as indexfopn3p92cmBHNc_45SCG57kFc9PrA5qtLL_513P5K9QowMeta } from "/var/www/panel/pages/journal/index.vue?macro=true";
import { default as reset_45passwordgy47vdZJ0y6yT4yV7pMxamZppi9enIT8_45S_45VJFLHSkUMeta } from "/var/www/panel/pages/reset-password.vue?macro=true";
import { default as _91id_939RTe_450hW0B_1BeVP0H2TWUf7ZSULuYuZDbiYuQ2omcMMeta } from "/var/www/panel/pages/admin/login/[id].vue?macro=true";
import { default as confirm_45new_45email0EU12KmuQS5c43vadgJAtGO_BLrR94Lhk8EWV52peVIMeta } from "/var/www/panel/pages/confirm-new-email.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: { ...(indexni6TxoxFOmNZNcqLCPfV0CyCSopciYghrbAuyzY3iocMeta || {}), ...{"middleware":["auth","home"]} },
    component: () => import("/var/www/panel/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: { ...(loginFtlvZ3e0paiUJCpU9FTGEf9JY8GrqGHvyACl6prkNosMeta || {}), ...{"middleware":["guest"]} },
    component: () => import("/var/www/panel/pages/login.vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: terms6KrDzNGApadzvsiM5ZEN1eXLGHUoIF5k_Vg0fwSWvfUMeta || {},
    component: () => import("/var/www/panel/pages/terms.vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: { ...(contacteOONcYOVoFoH9pRVYVMqDZV9Z2YGtuvjQRv66HQM9eMMeta || {}), ...{"middleware":["auth","contact"]} },
    component: () => import("/var/www/panel/pages/contact.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    meta: privacyMfIux7ciQDpbUCfsaEaaw0u9Joxb7se7QJQgb0Ongs8Meta || {},
    component: () => import("/var/www/panel/pages/privacy.vue")
  },
  {
    name: "schedule",
    path: "/schedule",
    meta: { ...(schedulelyUFOW1AlicCsYB1eITbvNUUJ7UbOm3TYlllvjXBg70Meta || {}), ...{"middleware":["auth","schedule"]} },
    component: () => import("/var/www/panel/pages/schedule.vue")
  },
  {
    name: "settings",
    path: "/settings",
    meta: { ...(settingsy8YdYalpq_xhnjQtuPXYfvlyqotO3QWzMPwo1i3SzCcMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/panel/pages/settings.vue")
  },
  {
    name: "decisions",
    path: "/decisions",
    meta: { ...(decisionsG56DvyZR40uJuQ09U7mNcl8E0dYPL2tyjA6pLsBMB1QMeta || {}), ...{"middleware":["auth","decisions"]} },
    component: () => import("/var/www/panel/pages/decisions.vue"),
    children: [
  {
    name: "decisions-id",
    path: ":id()",
    meta: { ...(_91id_9339Qb_DA5OPM_45R0adH6QjBf18dkYAw_5EaskV2rKMDUkMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/panel/pages/decisions/[id].vue")
  }
]
  },
  {
    name: "documents",
    path: "/documents",
    meta: { ...(documentsKWVy_ypaauj4_RqNHWebngzB9pJWBPXKVBnzFtYMtv0Meta || {}), ...{"middleware":["auth","documents"]} },
    component: () => import("/var/www/panel/pages/documents.vue")
  },
  {
    name: "checkboxes",
    path: "/checkboxes",
    meta: { ...(checkboxesBZ6d7UTdvGJvua6w_QUkp3oXZ2VujL0f8dBDZWmZoksMeta || {}), ...{"middleware":["auth","checkboxes"]} },
    component: () => import("/var/www/panel/pages/checkboxes.vue")
  },
  {
    name: "login-help",
    path: "/login-help",
    meta: { ...(login_45helpYmsXaEFhZDt_gFiyIHJrmfUdYw_45qqwoFZyFyAWcU48UMeta || {}), ...{"middleware":["guest"]} },
    component: () => import("/var/www/panel/pages/login-help.vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: { ...(indexIXi4rNfMefLrz5jRyPaJcVoSrkXTg1dx0FzUDor0FscMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/panel/pages/admin/index.vue")
  },
  {
    name: "settlements",
    path: "/settlements",
    meta: { ...(settlements2J3fSon7E_45WzwjpHZ4wrR7v5zsfY_ut_G3fIVblo5q4Meta || {}), ...{"middleware":["auth","settlements"]} },
    component: () => import("/var/www/panel/pages/settlements.vue")
  },
  {
    name: "admin-sentry",
    path: "/admin/sentry",
    meta: { ...(sentrymorWquOvgavxcEMnpiDMskvBMZ8_NRq6c_45NL5Nf7JyQMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/panel/pages/admin/sentry.vue")
  },
  {
    name: "journal-id",
    path: "/journal/:id()",
    meta: { ...(_91id_937nAyV6rzBkpiDng4Qv9_45n2SVQL3sEYpKYhgYad3HfxIMeta || {}), ...{"middleware":["auth","single-journal"]} },
    component: () => import("/var/www/panel/pages/journal/[id].vue")
  },
  {
    name: "journal",
    path: "/journal",
    meta: { ...(indexfopn3p92cmBHNc_45SCG57kFc9PrA5qtLL_513P5K9QowMeta || {}), ...{"middleware":["auth","journals"]} },
    component: () => import("/var/www/panel/pages/journal/index.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    meta: { ...(reset_45passwordgy47vdZJ0y6yT4yV7pMxamZppi9enIT8_45S_45VJFLHSkUMeta || {}), ...{"middleware":["guest","validate-reset-token"]} },
    component: () => import("/var/www/panel/pages/reset-password.vue")
  },
  {
    name: "admin-login-id",
    path: "/admin/login/:id()",
    meta: { ...(_91id_939RTe_450hW0B_1BeVP0H2TWUf7ZSULuYuZDbiYuQ2omcMMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/panel/pages/admin/login/[id].vue")
  },
  {
    name: "confirm-new-email",
    path: "/confirm-new-email",
    meta: { ...(confirm_45new_45email0EU12KmuQS5c43vadgJAtGO_BLrR94Lhk8EWV52peVIMeta || {}), ...{"middleware":["validate-confirm-email"]} },
    component: () => import("/var/www/panel/pages/confirm-new-email.vue")
  }
]